export const ADD = 'entities/organizers/ADD';
export const ADD_MULTIPLE = 'entities/organizers/ADD_MULTIPLE';
export const REMOVE = 'entities/organizers/REMOVE';
export const SET_TOTAL = 'entities/organizers/SET_TOTAL';
